@use "../../sass/global/global" as *;

ux-iws-slider-slide-zoomable {
    display: block;
    overflow: hidden;
    box-sizing: border-box;
    position: relative !important;

    .block-hero .block-shadow {
        display: none;

        @media (min-width: 568px) and (max-width: 1023px) {
            display: block;
            height: 20%;
        }
    }

    .block-zoom-image {
        display: none;
        overflow: hidden;
        position: relative;
        top: 0;
        left: 0;
    }

    .btn-zoom-wrapper {
        display: block;
        position: absolute;
        right: 30px;
        bottom: 30px;

        @media (max-width: 1024px) {
            display: none;
        }

        @media (min-width: 1440px) {
            display: none;
        }
    }

    .btn-zoom {
        appearance: none;
        background-color: $color-white;
        color: $color-black-text;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px;
        width: 36px;
        height: 36px;

        &:hover {
            background-color: $color-black-text;
            color: $color-white;
        }

        ux-icon {
            color: currentColor;
            font-size: 20px;
        }

        ux-icon[rel="zoom-out"] {
            display: none;
        }
    }
}

ux-iws-slider-slide-zoomable[is-zoomed] {
    .btn-zoom {
        ux-icon[rel="zoom-out"] {
            display: block;
        }

        ux-icon[rel="zoom-in"] {
            display: none;
        }
    }

    .block-zoom-image {
        display: block;
    }
}
